import LanguagePack from "../../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import PdfBulletListContent from "../../../../../../lib/html5-software-library/src/ranj/pdf/content/generic/PdfBulletListContent";
import PdfHorizontalContentContainer from "../../../../../../lib/html5-software-library/src/ranj/pdf/content/generic/PdfHorizontalContentContainer";
import PdfHorizontalLineContent from "../../../../../../lib/html5-software-library/src/ranj/pdf/content/generic/PdfHorizontalLineContent";
import AbstractPdfSection from "../../../../../../lib/html5-software-library/src/ranj/pdf/sections/AbstractPdfSection";
import BackendService from "../../../backend/controller/BackendService";
import ProgressModel from "../../../progress/model/ProgressModel";
import PersonalReportConfig from "../../model/PersonalReportConfig";

export default class ExploreFurtherSection extends AbstractPdfSection {
    /**
     * @constructor
     * @param {PersonalReportConfig} pdfConfig 
     * @param {LanguagePack} languagePack
     */
    constructor(pdfConfig, languagePack) {
        super(pdfConfig.pageWidth);

        this._pdfConfig = pdfConfig;
        this._languagePack = languagePack;
    }

    async loadData() {

    }

    initialize() {
        super.initialize();

        this.addPageBreak(true); // Always start on a new page.

        const title = this._languagePack.getText('personalReport.exploreFurther.title');
        this.addText(title, {
            ...this._pdfConfig.getValue("elements.general.h2"),
            size: 20,
            padding: [0, 0, 0, 0],
        });

        // Create sections.
        for (let i = 1; i < 10; i++) {
            const sectionExists = this._languagePack.hasText(`personalReport.exploreFurther.section${i}.title`);
            if (!sectionExists) {
                continue;
            }

            if (i > 1) {
                this.addContent(new PdfHorizontalLineContent(this._pdfConfig, this._pdfConfig.getValue("elements.general.hr")));
            }

            this._createContentSection(i);
        }

        this.addPageBreak(false);
    }

    _createContentSection(sectionIndex) {
        const title = this._languagePack.getText(`personalReport.exploreFurther.section${sectionIndex}.title`);
        this.addText(title, this._pdfConfig.getValue("elements.general.h3"));

        const subTitle = this._languagePack.getText(`personalReport.exploreFurther.section${sectionIndex}.subTitle`);
        this.addText(subTitle, this._pdfConfig.getValue("elements.general.i"));

        const whyTitle = this._languagePack.getText(`personalReport.exploreFurther.shared.whyTitle`);
        this.addText(whyTitle, this._pdfConfig.getValue("elements.general.h4"));
        const whyBody = this._languagePack.getText(`personalReport.exploreFurther.section${sectionIndex}.whyBody`);
        this.addText(whyBody, this._pdfConfig.getValue("elements.general.div"));

        const howTitle = this._languagePack.getText(`personalReport.exploreFurther.shared.howTitle`);
        this.addText(howTitle, this._pdfConfig.getValue("elements.general.h4"));

        const howBodyBullets = [];
        for (let i = 0; i < 15; i++) {
            const howBodyBulletItem = this._languagePack.getText(`personalReport.exploreFurther.section${sectionIndex}.howBody.bullet${i}`);
            if (!howBodyBulletItem) {
                break;
            }

            howBodyBullets.push(howBodyBulletItem);
        }
        const howBody = new PdfBulletListContent(null, howBodyBullets, this._pdfConfig.getValue("elements.general.div"));
        this.addContent(howBody);

        const tip = this._languagePack.getText(`personalReport.exploreFurther.section${sectionIndex}.tip`);
        this.addText(tip, {
            ...this._pdfConfig.getValue("elements.general.div"),
            padding: [8, 0, 0, 0],
        });

        this.addPageBreak(false); // Allow breaking between sections.
    }
}